import { useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useLead } from '@/hooks/useLead';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import FormField from '@/components/FormField/FormField';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { validateContactsForm, isFormValid } from '@/utils/validators';
import styles from '@/styles/forms.module.scss';

export default function ContactsScreen() {
  const { t } = useLocalization();
  const { leadData, setName, setCompany, setEmail, setPhone } = useLead();
  const { submitContacts } = useChat();
  const [errors, setErrors] = useState({ name: null, company: null, email: null, phone: null });

  const handleSubmit = async () => {
    const errs = validateContactsForm(leadData);
    setErrors(errs);
    if (isFormValid(errs)) {
      await submitContacts();
    }
  };

  return (
    <BotMessage text={t('contacts.message')}>
      <div className={styles.contactsForm}>
        <FormField
          id="ibc-name"
          label={t('contacts.nameLabel')}
          type="text"
          placeholder={t('contacts.namePlaceholder')}
          value={leadData.name}
          onChange={setName}
          error={errors.name}
        />
        <FormField
          id="ibc-company"
          label={t('contacts.companyLabel')}
          type="text"
          placeholder={t('contacts.companyPlaceholder')}
          value={leadData.company}
          onChange={setCompany}
          error={errors.company}
        />
        <FormField
          id="ibc-email"
          label={t('contacts.emailLabel')}
          type="email"
          placeholder={t('contacts.emailPlaceholder')}
          value={leadData.email}
          onChange={setEmail}
          error={errors.email}
        />
        <FormField
          id="ibc-phone"
          label={t('contacts.phoneLabel')}
          type="tel"
          placeholder={t('contacts.phonePlaceholder')}
          value={leadData.phone}
          onChange={setPhone}
          error={errors.phone}
        />
        <OptionButton variant="primary" onClick={handleSubmit}>
          {t('contacts.submit')}
        </OptionButton>
      </div>
    </BotMessage>
  );
}
